import { Accepts, Types } from "@citychallenge/common";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class MatchingPairProps {
  @Inlet(Accepts.Image) public media?: Types["Image"];
  @Inlet(Accepts.MarkdownText) public introduction!: Types["MarkdownText"];

  @Inlet(Accepts.MatchPairType) public columnOneType!: Types["MatchPairType"];
  @Inlet(Accepts.MatchPairType) public columnTwoType!: Types["MatchPairType"];

  @Inlet(Accepts.MatchPairValueList) public pairs!: Types["MatchPairValueList"];
}

export const MatchingPairDefinition = defineElement(
  "matching-pair",
  MatchingPairProps,
  {
    versionRequired: "0.37.0",
  }
);
